import { Select } from "antd";
import React from "react";
import {  cuentasEspecialesLabelvalue } from "../../constants/cons";

export const CuentasEspecialesSelect = ({ onChange }) => {
  return (
    <>
      <div className="labelImput">Cuentas Especiales</div>
      <Select
      placeholder="Selecciona Cuenta Especial"
        style={{ width: "100%" }}
        onChange={onChange}
        options={cuentasEspecialesLabelvalue}
      />
    </>
  );
};
